import { NEWCAPABILITIES, apiCallStatus } from 'helpers/constants';
import { actionTypes } from './constants';
import { SubscriptionInfoApi, CapabilityApi, AssetDetailsApi, AssetLabelsApi, ComponentApi } from 'api/index';
import { getApiActionCreator } from 'helpers/actionHelper';
import { modifiedDriveEvents } from './helpers';
import { toLocalDateTimeOffsetString } from 'helpers/dateHelper';
import moment from 'moment';

const getContractsAction = getApiActionCreator(actionTypes.ACTIVE_SUB_DATA);
const getNewCapabilitiesAction = getApiActionCreator(actionTypes.GET_ASSET_NEWCAPABILITIES);
const getAssetOverviewAction = getApiActionCreator(actionTypes.GET_ASSET_OVERVIEW);
const getAssetLabelsAction = getApiActionCreator(actionTypes.LOAD_ASSET_LABELS);
const getDriveEventsSummaryAction = getApiActionCreator(actionTypes.GET_DRIVE_EVENTS_SUMMARY);
const getSmartConditionSummaryAction = getApiActionCreator(actionTypes.GET_SMART_CONDITION_SUMMARY);

export const getSubscriptionInfo = (assetIdParams) => {
    return (dispatch) => {
        dispatch(getContractsAction(apiCallStatus.LOADING));
        SubscriptionInfoApi.getSubscriptionList(assetIdParams)
            .then((data) => {
                dispatch(getContractsAction(apiCallStatus.SUCCESS, data));
            }, (err) => {
                dispatch(getContractsAction(apiCallStatus.ERROR, null, err));
            });
    };

};

export const getApiAssetCapability = (asset) => {
    return (dispatch, getState) => {
        const organizationId = getState().generalFilter.selectedFilters.organizations[0].organizationID;
        const capabilityCodes = Object.values(NEWCAPABILITIES);
        dispatch(getNewCapabilitiesAction(apiCallStatus.LOADING));
        return CapabilityApi.getCapabilities(organizationId, [asset.id], capabilityCodes)
            .then((capabilities) => {
                dispatch(getNewCapabilitiesAction(apiCallStatus.SUCCESS, capabilities));
            }, (err) => {
                dispatch(getNewCapabilitiesAction(apiCallStatus.ERROR, [], err));
            });
    };
};

export const getAssetOverview = (assetID) => {
    return (dispatch) => {
        dispatch(getAssetOverviewAction(apiCallStatus.LOADING));
        AssetDetailsApi.getAssetOverview(assetID)
            .then(data => {
                dispatch(getAssetOverviewAction(apiCallStatus.SUCCESS, data));
            }, (err) => {
                dispatch(getAssetOverviewAction(apiCallStatus.ERROR, null, err));
            });
    };
};

export const getAssetLabels = (assetID) => {
    return (dispatch) => {
        dispatch(getAssetLabelsAction(apiCallStatus.LOADING));
        AssetLabelsApi.getAssetTags(assetID)
            .then((labels) => {
                dispatch(getAssetLabelsAction(apiCallStatus.SUCCESS, labels));
            }, (err) => {
                dispatch(getAssetLabelsAction(apiCallStatus.ERROR, [], err));
            });
    };
};

export const getDriveEventsSummary = (assetId) => {
    return (dispatch) => {
        const startTime = toLocalDateTimeOffsetString(moment().startOf('day').toDate());
        const endTime = toLocalDateTimeOffsetString(moment().toDate());
        dispatch(getDriveEventsSummaryAction(apiCallStatus.LOADING));
        ComponentApi.getDriveEventsSummary(assetId, startTime, endTime)
            .then((data) => {
                const modifiedData = data && !data?.message ? modifiedDriveEvents(data) : null;
                dispatch(getDriveEventsSummaryAction(apiCallStatus.SUCCESS, modifiedData));
            }, (err) => {
                dispatch(getDriveEventsSummaryAction(apiCallStatus.ERROR, null, err));
            });
    };
};

export const getSmartConditionSummary = (assetId) => {
    return (dispatch) => {
        dispatch(getSmartConditionSummaryAction(apiCallStatus.LOADING));
        AssetDetailsApi.getSmartConditionSummary(assetId)
            .then((data) => {
                dispatch(getSmartConditionSummaryAction(apiCallStatus.SUCCESS, data));
            }, (err) => {
                dispatch(getSmartConditionSummaryAction(apiCallStatus.ERROR, null, err));
            });
    };
};
